<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc"></a>
<a id="page_vii"></a>
<h2 class="title1">CONTENTS</h2>
<p class="toc-front" id="toc_p1">
<a href="#/preface">Preface</a>
</p>
<p class="toc-chapter" id="toc_p2">
<a href="#/chap01"><i>1</i><br/>TRICKS</a>
</p>
<p class="toc-chapter" id="toc_p3">
<a href="#/chap02"><i>2</i><br/>IMAGERY</a>
</p>
<p class="toc-chapter" id="toc_p4">
<span href="#/chap03" title="Link target outside of Sample"><i>3</i><br/>SAMPLING</span>
</p>
<p class="toc-chapter" id="toc_p5">
<span href="#/chap04" title="Link target outside of Sample"><i>4</i><br/>CONCEPTS</span>
</p>
<p class="toc-chapter" id="toc_p6">
<span href="#/chap05" title="Link target outside of Sample"><i>5</i><br/>LOGIC</span>
</p>
<p class="toc-front" id="toc_p7">
<span href="#/back1" title="Link target outside of Sample">Coda</span>
</p>
<p class="toc-front" id="toc_p8">
<span href="#/reference" title="Link target outside of Sample">References</span>
</p>
<p class="toc-front" id="toc_p9">
<span href="#/index" title="Link target outside of Sample">Index</span>
</p>
<a id="page_viii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6244d406